/* IronGrind – funnel click tracking.
   Shopify's own analytics already records product views, add to cart, checkout starts and purchases
   (Customer Events: product_viewed, product_added_to_cart, checkout_started, checkout_completed).
   This file adds the clicks Shopify does not capture: homepage door / category / collab clicks.
   Each click is published three ways so any installed tool can read it:
     1. Shopify.analytics.publish('iga_<event>')  -> available to custom pixels (Settings > Customer events)
     2. window.dataLayer.push({event: 'iga_<event>'}) -> Google Tag Manager, if added later
     3. clarity('event', 'iga_<event>')            -> Microsoft Clarity (already installed)
   Tag any link with data-iga-track="category_click" (or collab_click, door_click) and data-iga-label.
   Header menu links to /collections/ are tagged automatically as nav_category_click. */
(function () {
  function send(name, data) {
    var ev = 'iga_' + name;
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, data); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, data)); } catch (e) {}
    try { if (typeof window.clarity === 'function') { window.clarity('event', ev); window.clarity('set', ev, data.label || ''); } } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button');
    if (!el) return;
    var tagged = el.closest('[data-iga-track]');
    var name = tagged ? tagged.getAttribute('data-iga-track') : null;
    var href = el.getAttribute('href') || '';
    if (!name && el.closest('header, .header, [data-header]') && href.indexOf('/collections/') > -1) name = 'nav_category_click';
    if (!name) return;
    send(name, {
      label: (tagged && tagged.getAttribute('data-iga-label')) || (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      destination: href,
      section: (tagged && tagged.getAttribute('data-iga-section')) || '',
      page: window.location.pathname
    });
  }, true);
})();
